import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import {
  TextField,
  FormGroup,
  MenuItem,
  FormControl,
  Card,
  CardContent,
  Grid,
  Tooltip,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import * as Yup from 'yup';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';

import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import { useStyles } from '../../components/Styles';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import GroupButton from '../../components/Buttons/ButtonGroup';
import './styles.css';
import styleGlobal from '../../Global.module.css';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import { labelField } from 'utils';

function Supply() {
  const location = useLocation();
  const [openProgress, setOpenProgress] = useState(false);
  const [unities, setUnities] = useState([]);
  const [isStocked, setIsStocked] = useState('true');
  const [types, setTypes] = useState([]);
  const error = Error();
  const success = Success();
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  let { id } = useParams();
  const disable = useSelector((state) => state.disable.disable);
  const [allUnities, setAllUnities] = useState([]);

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setDataLocation(location.state.customData);
        formik.setFieldValue('id', null);
      } else if (location.state.data) {
        id = location.state.id;
        setDataLocation(location.state.data);
        if (location.state.data.stock === null) {
          formik.setFieldValue('unity', 'Quilograma');
        } else {
          formik.setFieldValue('unity', location.state.data.stock.unity.name);
        }
      }
    }
  }, [location]);

  function setDataLocation(data) {
    formik.setValues(data);
    formik.setFieldValue('unity', data.stock?.unity);
    setIsStocked(data.isStocked ? 'true' : 'false'); // usando string pq o combobox só sabe lidar com string
    formik.setFieldValue('type', data.type.id);
  }

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      name: '',
      band: '',
      type: '',
      unity: '',
      isStocked: true,
      description: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().max(
        99,
        'Máximo de caracteres ultrapassado (100 caracteres).',
      ).required('Campo Obrigatório'),
      type: Yup.string().required('Campo Obrigatório'),
      band: Yup.string().max(
        49,
        'Máximo de caracteres ultrapassado (50 caracteres).',
      ),
      unity: Yup.string().required('Campo Obrigatório'),
      description: Yup.string()
        .max(100, 'Máximo de caracteres ultrapassado (100 caracteres).')
        .nullable(),
    }),
    onSubmit: (values) => {
      if (equals) return false;
      dispatch(setLoading(true));
      request(values);
    },
  });

  useEffect(() => {
    api.get('/unities').then((unities_) => {
      setUnities(unities_.data);
      setAllUnities(unities_.data);
    });
    api.get('/supply-types').then((types_) => {
      setTypes(types_.data);
    });
  }, []);

  async function request(data) {
    // envia os dados para api salvar no banco
    dispatch(setDisable(true));
    try {
      id
        ? await api.put(`/supplies/${id}`, {
          ...data,
          unity: unities.find((unity) => unity.name === data.unity).id,
        })
        : await api.post('/supplies', {
          ...data,
          unity: unities.find((unity) => unity.name === data.unity).id,
        });
      success();
      history.push('/supplies');
    } catch (err) {
      error();
      // eslint-disable-next-line no-console
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  // VERIFICAÇÂO DO INPUT NAME COM OS SUPPLIES
  const [data, setData] = useState();
  const [equals, setEquals] = useState(false);
  useEffect(() => {
    async function load() {
      const dados = await api.get('/supplies');
      setData(dados.data);
    }
    load();
  }, []);

  useEffect(() => {
    setEquals(false);
    let url = window.location.pathname;
    url = url.split('/');
    const ide = url[2];
    data
      && data.map((supply) => (supply.name === formik.values.name
        ? supply.id != ide
          ? setEquals(true)
          : null
        : null));
  }, [formik.values.name, data]);

  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  // Filtragem de tipo de insumo
  useEffect(() => {
    if (formik.values.type === 1) {
      setUnities(unities.filter((unity) => unity.sigla === 'kg' || unity.sigla === 'g'));
    } else {
      setUnities(allUnities);
    }
  }, [formik.values.type]);

  return (
    <header className={styleGlobal.headerGlobal}>
      <Card style={{ padding: '2rem', borderRadius: '20px' }}>
        {openProgress ? <Progress /> : null}
        {' '}
        {/** Carregamento circular para o carregamento dos dados */}
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.root}>
            <h2 style={{ marginBottom: '2rem' }}>
              Dados do Insumo
              {' '}
              <HtmlTooltip
                title={(
                  <>
                    Essa tela possibilita controlar entradas de insumos, incluindo arraçoamento, insumos químicos, aditivos e biorremediadores, bem como misturas de vários compostos.
                  </>
                )}
                placement="right"
                arrow
                interactive
              >
                <InfoIcon color="primary" fontSize="inherit" />
              </HtmlTooltip>
            </h2>
            <CardContent style={{ padding: '0rem' }}>
              <Grid container spacing={2}>
                <Grid item xs={6} sm={12}>
                  <FormGroup>
                    <TextField
                      inputProps={{ maxLength: 100 }}
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="name"
                      label={labelField('Nome', 'Identificação do insumo')}
                      variant="outlined"
                      name="name"
                      type="text"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        !!(formik.touched.name && formik.errors.name) || equals
                      }
                      helperText={
                        equals
                          ? 'Já temos um insumo com este nome'
                          : null
                          || (formik.touched.name
                            && formik.errors.name
                            && formik.errors.name)
                      }
                    />
                  </FormGroup>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <FormGroup>
                    <TextField
                      inputProps={{ maxLength: 50 }}
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="band"
                      label={labelField('Marca', 'Marca atribuída ao insumo', false)}
                      variant="outlined"
                      name="band"
                      type="text"
                      value={formik.values.band}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={!!(formik.touched.band && formik.errors.band)}
                      helperText={
                        formik.touched.band
                        && formik.errors.band
                        && formik.errors.band
                      }
                    />
                  </FormGroup>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <FormGroup>
                    <TextField
                      // InputLabelProps={{ style: { pointerEvents: "auto" } }}
                      id="type"
                      select
                      label={labelField('Tipo')}
                      onChange={formik.handleChange}
                      variant="outlined"
                      value={formik.values.type}
                      name="type"
                      // as="select"
                      onBlur={formik.handleBlur}
                      error={!!(formik.touched.type && formik.errors.type)}
                      helperText={
                        formik.touched.type
                        && formik.errors.type
                        && formik.errors.type
                      }
                    >
                      {types.map((type) => (
                        <MenuItem key={type.id} value={type.id}>
                          {type.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </FormGroup>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <FormGroup>
                    {isStocked === 'true' ? (
                      <FormControl variant="outlined" fullWidth>
                        <TextField
                          label={labelField('Unidade de medida de consumo')}
                          fullWidth
                          variant="outlined"
                          value={
                            formik.values.stock != null
                              ? formik.values.stock.unity.name
                              : formik.values.unity
                          }
                          select
                          // as="select"
                          onBlur={formik.handleBlur}
                          error={
                            !!(formik.touched.unity && formik.errors.unity)
                          }
                          helperText={
                            formik.touched.unity
                            && formik.errors.unity
                            && formik.errors.unity
                          }
                          onChange={(e) => {
                            const unity = unities.find(
                              (unity) => unity.name === e.target.value,
                            );
                            formik.setFieldValue('stock.unity', unity);
                            formik.setFieldValue('unity', unity.name);
                          }}
                        >
                          {unities?.map((account) => (
                            <MenuItem key={account.id} value={account.name}>
                              {account.name}
                              {' '}
                              (
                              {account.sigla}
                              )
                            </MenuItem>
                          ))}
                        </TextField>
                      </FormControl>
                    ) : null}
                  </FormGroup>
                </Grid>
                <Grid item xs={6} sm={12}>
                  <FormGroup>
                    <TextField
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="description"
                      label={<div>Descrição (Opcional)</div>}
                      multiline
                      variant="outlined"
                      name="description"
                      type="text"
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      onKeyDown={formik.handleBlur}
                      error={
                        !!(
                          formik.touched.description
                          && formik.errors.description
                        )
                      }
                      helperText={
                        formik.touched.description
                        && formik.errors.description
                        && formik.errors.description
                      }
                    />
                  </FormGroup>
                </Grid>
              </Grid>
            </CardContent>
          </div>
          <GroupButton
            deleteRoute="/supplies/"
            routeDelete="/supplies"
            returnRoute="/supplies"
            id={id}
            disable={disable}
            message="A exclusão desse suprimento pode levar a exclusão de objetos que dependam dele. Tem certeza que deseja excluir?"
          />
        </form>
      </Card>
    </header>
  );
}
export default Supply;
